import { DEFAULT_CONTEXT } from "constants/context";
import React from "react";

const GlobalContext = React.createContext(DEFAULT_CONTEXT);

export default GlobalContext;
